export default __webpack_public_path__ + "static/media/time.2e4ecb0f.svg";